import { render, staticRenderFns } from "./PinPostoAvancado.vue?vue&type=template&id=4773a3dc&scoped=true"
import script from "./PinPostoAvancado.vue?vue&type=script&lang=js"
export * from "./PinPostoAvancado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4773a3dc",
  null
  
)

export default component.exports